import styled, { css } from 'styled-components';

import { getFontStyle, rem, toRemString } from '../../utils';
import { StatusType } from '../Status';

export const StyledWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledBadgeStatus = styled.span(({ theme }) => {
  return css`
    border-radius: ${rem(theme.Border.Radius.XSmall)};
    padding: ${toRemString([theme.Sizes.X3Small, theme.Spacing.Size.XSmall])};
    border: ${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    background-color: ${theme.Color.Neutrals.Light};
    ${getFontStyle('Small')}
  `;
});

export const StyledOutlinedStatus = styled.span<{
  type: StatusType;
}>(({ theme, type }) => {
  const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);

  return css`
    background-color: ${theme.Color.Feedback[`${capitalizedType}Light`]};
    color: ${theme.Color.Feedback[capitalizedType]};
    border-radius: ${rem(theme.Border.Radius.Small)};
    padding: ${toRemString([
      theme.Spacing.Size.XXSmall - 1,
      theme.Spacing.Size.XSmall,
    ])}; // -1 to compensate for the border
    border: ${rem(theme.Border.Size.Small)} solid
      ${`${theme.Color.Feedback[`${capitalizedType}`]}3D`};
    ${getFontStyle('Small')}
    line-height: ${rem(theme.Typography.Size.Small.FontSize)};
  `;
});
